import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import axios from 'axios';

import SituationMapCard from '../components/dashboard/SituationMapCard';
import DashboardFullscreenMap from '../components/dashboard/DashboardFullscreenMap';
import { MAP_EDIT_ROLES } from '../components/map/buildingIcons';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CartePage = () => {
    const { token, user } = useAuth();
    const canDraw = MAP_EDIT_ROLES.includes(user?.role);
    const { theme } = useTheme();
    const [incidents, setIncidents] = useState([]);
    const [careCenters, setCareCenters] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [dangerZones, setDangerZones] = useState([]);
    const [drawings, setDrawings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fsMapOpen, setFsMapOpen] = useState(false);

    const fetchData = useCallback(async () => {
        try {
            const headers = { Authorization: `Bearer ${token}` };
            const [incidentsRes, centersRes, vehiclesRes, zonesRes, drawingsRes] = await Promise.all([
                axios.get(`${API}/incidents?active_only=true`, { headers }),
                axios.get(`${API}/care-centers?status=open`, { headers }),
                axios.get(`${API}/vehicles`, { headers }),
                axios.get(`${API}/services-techniques/zones-dangereuses`, { headers }).catch(() => ({ data: [] })),
                axios.get(`${API}/map/drawings`, { headers }).catch(() => ({ data: [] }))
            ]);
            setIncidents(incidentsRes.data);
            setCareCenters(centersRes.data);
            setVehicles(vehiclesRes.data);
            setDangerZones(zonesRes.data);
            setDrawings(drawingsRes.data);
        } catch (error) {
            console.error('Failed to fetch map data:', error);
        } finally {
            setLoading(false);
        }
    }, [token]);

    useEffect(() => {
        fetchData();
        const interval = setInterval(fetchData, 30000);
        return () => clearInterval(interval);
    }, [fetchData]);

    const mapCenter = incidents.length > 0
        ? [incidents[0].latitude, incidents[0].longitude]
        : careCenters.length > 0
        ? [careCenters[0].latitude, careCenters[0].longitude]
        : [46.603354, 1.888334];

    if (loading) {
        return (
            <div className="flex items-center justify-center h-full">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    return (
        <div className="space-y-6" data-testid="carte-page">
            <div className="page-header">
                <h1 className="page-title">Carte de situation</h1>
                <p className="page-subtitle">Vue en temps reel des incidents, centres CARE et vehicules</p>
            </div>

            <div className="grid grid-cols-1 gap-6">
                <SituationMapCard
                    theme={theme} mapCenter={mapCenter} zoom={13}
                    incidents={incidents} careCenters={careCenters} vehicles={vehicles} dangerZones={dangerZones} drawings={drawings}
                    onFullscreen={() => setFsMapOpen(true)}
                />
            </div>

            <DashboardFullscreenMap
                open={fsMapOpen} onClose={() => { setFsMapOpen(false); fetchData(); }} mapCenter={mapCenter} theme={theme} token={canDraw ? token : null} drawings={drawings}
                incidents={incidents} careCenters={careCenters} vehicles={vehicles} dangerZones={dangerZones}
            />
        </div>
    );
};

export default CartePage;
